<app-in-app-page>
  <app-header title="Phone book"></app-header>

  <main class="phone-book">
    <div class="phone-book-search-bar">
      <div class="form-input-wrapper">
        <input
          class="form-input_lg"
          placeholder="Enter search criteria"
          [(ngModel)]="contactsSearchParams.searchString"
        />
        <button class="btn_plain btn_sm search-button" (click)="getContacts()">Search</button>
      </div>

      <button class="btn_primary btn_sm" (click)="openCreateContactModal()">New contact</button>
    </div>

    <app-contact-list
      [contacts]="contacts"
      [isLoading]="isContactsLoading"
      (sendToContactClick)="navigateToSendFax($event)"
      (editContactClick)="openEditContactModal($event)"
      (deleteContactClick)="openDeleteContactModal($event)"
    ></app-contact-list>
  </main>
</app-in-app-page>

<app-create-contact-modal (submit)="createContact($event)"></app-create-contact-modal>

<app-edit-contact-modal [contact]="selectedContact" (submit)="updateContact($event)"></app-edit-contact-modal>

<app-delete-contact-modal
  [contactName]="selectedContact?.name"
  (submit)="deleteContact()"
></app-delete-contact-modal>
